var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{attrs:{"disabled":_vm.disabled},on:{"change":_vm.handleSelectChange},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},_vm._l((_vm.nams),function(item){return _c('a-select-option',{key:item.roleId,attrs:{"value":item.name}},[_vm._v(_vm._s(item.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }